<c-modal #successModal backdrop="static" size="sm" visible='true' id="petDetailModal">
  <c-modal-header>
      <h4 class="modal-title">{{ title }}</h4>
      <button type="button" title="Close" [cModalToggle]="successModal.id" cButtonClose (click)="closeModal()"></button>
  </c-modal-header>
  <c-modal-body>
    <p>{{ message }}</p>
  </c-modal-body>
  <!-- <c-modal-footer>
    <button cButton color="secondary" (click)="closeModal()">Close</button>
    <button cButton color="primary" (click)="savePetDetail()">Submit</button>
  </c-modal-footer> -->
</c-modal>
